import React from 'react';
import { Phone, CheckCircle2, Users, Award, TrendingUp, Clock } from 'lucide-react';
import { phoneNumber, whatsappLink } from '../data/mock';
import { Button } from '../components/ui/button';

const HomeHero = () => (
  <section
    className="relative pt-28 pb-16 overflow-hidden"
    style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1711559524964-faa0d156d822?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxzcGlyaXR1YWwlMjBjYW5kbGVzfGVufDB8fHx8MTc2OTc3NTY1MXww&ixlib=rb-4.1.0&q=85)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}
  >
    <div className="absolute inset-0 bg-gradient-to-b from-black via-black/85 to-black"></div>
    
    <div className="container mx-auto px-4 relative z-10">
      <div className="max-w-5xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 mb-5 px-6 py-2 bg-amber-500/20 backdrop-blur-sm rounded-full border border-amber-400/30 animate-pulse">
          <Award className="w-5 h-5 text-amber-400" />
          <p className="text-amber-400 font-semibold text-sm md:text-base">Grand Marabout Africain Certifié</p>
        </div>
        
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-5 bg-gradient-to-r from-amber-200 via-amber-400 to-amber-200 bg-clip-text text-transparent leading-tight px-4">
          Faire Revenir Son Ex Rapidement - Marabout Puissant Efficace
        </h1>
        
        <p className="text-base sm:text-lg md:text-xl text-amber-100/90 mb-6 leading-relaxed max-w-4xl mx-auto px-4">
          <strong className="text-amber-400">Marabout puissant et efficace</strong> spécialisé dans le <span className="text-amber-400 font-bold">retour affectif rapide garanti</span>. Comment <span className="text-red-400 font-bold">faire revenir son ex</span> rapidement ? <span className="text-amber-400 font-bold">Récupérer son ex</span>-mari, ex-femme, ex-copain ? Les rituels du <span className="text-amber-400 font-bold">Grand Marabout</span> avec <span className="text-amber-400 font-bold">voyance sérieuse</span> vous garantissent le retour de l'être aimé. Plus de <span className="text-amber-400 font-bold">2400 clients ont réussi à faire revenir leur ex</span>. <span className="text-red-400 font-bold">Résultats garantis sous 7 jours.</span> Consultation gratuite 24/7.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8 px-4">
          <a href={`tel:${phoneNumber}`}>
            <Button className="w-full sm:w-auto bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white px-8 py-6 text-base md:text-lg shadow-2xl shadow-red-500/50 transform hover:scale-105 transition-all duration-300">
              <Phone className="mr-2" size={20} />
              {phoneNumber}
            </Button>
          </a>
          
          <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
            <Button className="w-full sm:w-auto bg-green-600 hover:bg-green-700 text-white px-8 py-6 text-base md:text-lg shadow-2xl shadow-green-500/50 transform hover:scale-105 transition-all duration-300">
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
              </svg>
              Consultation WhatsApp
            </Button>
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 max-w-4xl mx-auto mb-6 px-4">
          {[
            { icon: Users, value: '2400+', label: 'Clients Satisfaits', color: 'amber', border: 'amber' },
            { icon: TrendingUp, value: '98%', label: 'Taux de Réussite', color: 'green', border: 'green' },
            { icon: Award, value: '25+', label: "Ans d'Expérience", color: 'amber', border: 'amber' },
            { icon: Clock, value: '24/7', label: 'Disponibilité', color: 'green', border: 'green' },
          ].map((stat) => (
            <div key={stat.label} className={`bg-zinc-900/60 backdrop-blur-md border border-${stat.border}-500/30 rounded-xl p-3 md:p-4 transform hover:scale-105 transition-all duration-300`}>
              <div className="flex items-center justify-center gap-2 mb-1">
                <stat.icon className={`w-5 h-5 text-${stat.color}-400`} />
                <span className={`text-xl md:text-2xl font-bold text-${stat.color}-400`}>{stat.value}</span>
              </div>
              <p className="text-xs md:text-sm text-amber-100/70">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-sm px-4">
          {['Consultation Gratuite', 'Résultats garantis', 'Discrétion Absolue'].map((item) => (
            <div key={item} className="flex items-center space-x-2 text-amber-200">
              <CheckCircle2 size={18} className="text-green-500" />
              <span>{item}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default HomeHero;
